<div class="carousel-container">
  <div class="slider-container">
    @for (image of images(); track image.imageUrl; let i = $index) {
      <div class="slides fade"
           [class.active]="i === currentSlideIndex">
        <a [href]="HELPER.getUrl(image.sourceUrl)">
          <img [src]="image.imageUrl" fetchpriority="auto" alt="" width="372" height="360"/>
          <div class="description-container">
            <div class="text-l text--bold short-title"
                 [innerHTML]="image.title | stripHtml | safeHtmlMin | safeHtml"></div>
            <div class="text--white description"
                 [innerHTML]="image.description | stripHtml | safeHtmlMin | safeHtml "></div>
          </div>
        </a>
      </div>
    }
  </div>
  <div class="text-center dots">
    @for (dots of dotsLength; track dots; let i = $index; ) {
      <span [class.active]="currentSlideIndex  === i" (click)="goToSlide(i)" class="dot"></span>
    }
  </div>
</div>
